export interface IDisplayDurationProps {date: string}

const DisplayDate: React.FC<IDisplayDurationProps> = ({date}) => {
    const formattedString = `${date}`.slice(0, 10);
    return <p className={"standardText"}>{formattedString}</p>
}

export default DisplayDate;